export class AloJwt {

    public tkCore:string
    public tkHash:string
    public ttl:number
    public renewInSeconds:number

    constructor({tkCore = "", tkHash ="",ttl = 3600,renewInSeconds = 3300} = {}) {
        this.tkCore = tkCore
        this.tkHash = tkHash
        this.ttl = ttl
        this.renewInSeconds = renewInSeconds
    }
}